import React, { useContext, useMemo } from "react";
import clsx from "clsx";

import { Context } from "../../../../teacherStore";
import { getStudentAnswersByQuestion } from "../../../../libs/ActiveLearning";
import styles from "../ActiveLearningLessonAnswerData.module.scss";

interface ILesson9Pros {
  materialCode: string;
  lessonNo: number;
}

export const Lesson9: React.FC<ILesson9Pros> = ({ materialCode, lessonNo }) => {
  const { state } = useContext(Context);
  const activeLearningStudentAnswers = state.active_learning_student_answers;

  const answersL9I1Q1 = useMemo(() => {
    const answers = getStudentAnswersByQuestion(
      materialCode,
      activeLearningStudentAnswers,
      lessonNo,
      1,
      1,
    );

    return answers.length > 0
      ? answers.map(answer => answer.contents.value).join("")
      : "回答データがありません。";
  }, [materialCode, activeLearningStudentAnswers, lessonNo]);

  return (
    <div className={styles.lesson}>
      <p className={styles.title}>
        Lesson{lessonNo < 10 ? `0${lessonNo}` : lessonNo}{" "}
        自分だけの課題解決ストーリーを描こう
      </p>
      <div className={styles.inner}>
        <div className={styles.work}>
          <p className={styles.no}>WORK01</p>
          <p className={styles.heading}>
            今までの回答を振り返りながら、発表するための資料をつくろう。
          </p>
          <div className={styles.question}>
            <p className={clsx(styles.heading, styles.dot)}>
              内容を充実させるための補足情報を入力しよう。
            </p>
            <p className={clsx(styles.answer, styles.high)}>{answersL9I1Q1}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Lesson9;
